<template>
  <div class="about">
    <div class="box2" ref="anch1">
      <div class="title">管理团队</div>
      <div class="accordion">
        <div
          class="sam"
          v-for="(item, index) in tab2"
          :key="index"
          @click="asscli(index)"
          :style="`background-image:url(${item.mphoto&&$imgurl+item.mphoto.url})`"
        >
          <div class="name">
            <div class="top">{{ item.title }}</div>
            <div class="bottom">{{ item.subtitle }}</div>
          </div>
          <div class="blk">
            <!-- <img :src="$imgurl + item.photo.url" alt="" /> -->
          </div>
          <!-- v-show="curindex == index" -->
          <div class="text" >
            <div class="txt_w" v-html="item.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let WOW = require("wowjs");
export default {
  name: "About",
  data() {
    return {
      curindex: 0,
      tab2: [],
    };
  },
  methods: {
    asscli(index) {
      this.curindex = index;
    },
    //数据请求
    getdata() {
      this.$fetch({
        url: "index.php/about/initPage",
        type: "get",
      }).then((res) => {
        this.tab2 = res.data.tab2;
        this.$nextTick(() => {
          let wow = new WOW.WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true,
          }).init();
        });
      });
    },
  },
  mounted() {
    this.getdata();
  },
};
</script>

<style scoped>
.box2 {
  border-top: 1px solid #dfdfdf;
  background: #f0f2f5;
  padding-bottom: 30px;
}
.box2 .title {
  padding: 68px 0 50px 0;
  margin: 0 auto;
  position: relative;
  font-size: 36px;
  font-weight: 400;
  /* width: 160px; */
  text-align: center;
  height: 50px;
  color: #333333;
  letter-spacing: 4px;
  margin-bottom: 40px;
}
.box2 .title img {
  width: 624px;
  height: 50px;
  position: absolute;
  bottom: 60px;
  left: calc(50% - 312px);
  z-index: -1;
}
.box2 .accordion {
  width: 690px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.box2 .sam {
  width: 690px;
  height: 789px;
  position: relative;
  transition: all 0.3s linear;
  cursor: pointer;
  margin-bottom: 30px;
  background-image: url(../assets/imgapp/l.png);
  background-size: cover;
}
.box2 .big {
  width: 328px;
  height: 404px;
}
.box2 .name {
  margin: 42px 0 0 24px;
  color: #fff;
}
.box2 .blk img {
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 600px;
  height: 700px;
}
.box2 .name .top {
  font-size: 36px;
}
.box2 .name .bottom {
  font-size: 24px;
}
.box2 .sam .text {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 278px;
  background: linear-gradient(
    90deg,
    hsla(219, 47%, 38%, 0.8) 0%,
    hsla(220, 77%, 12%, 0.8) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
}
.box2 .sam .text .txt_w {
  width: 620px;
  height: 230px;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
  line-height: 38px;
}
</style>